import { z } from 'zod';

/**
 * Every entity id in Aysar is a uuid. Ids arrive from clients as route params
 * and body fields and are ALWAYS validated before they reach a repository —
 * never interpolated into SQL as free text.
 */
export const UuidSchema = z.uuid();

export type Uuid = z.infer<typeof UuidSchema>;

/** Narrows an arbitrary string to a uuid. */
export function isUuid(value: string): value is Uuid {
  return UuidSchema.safeParse(value).success;
}
